<template>
    <div class="p-1 rounded-20 text-tc-blue-1 border border-tc-blue-1 my-4 w-44">
        <div class="flex justify-start text-20 items-center relative">
            <div class="cursor-pointer px-2" @click="showMonthDropdrow()">{{ selectMonthText ? selectMonthText : 'เดือน'}}</div>
            <div>/</div>
            <div class="cursor-pointer px-2" @click="showYearDropdrow()">{{ selectYearText ? selectYearText : 'ปี'}}</div>
            <img class="h-2 w-2.5 absolute top-2 right-3" src="../../../../assets/icon/ic-arrow-down.png" />
        </div>
        <div class="relative" ref="dropdown-btn">
            <div v-show="showMonthList && monthList.length > 0"
                ref="ddl-list-area"
                class="absolute left-0 w-full bg-white border rounded-md overflow-hidden z-index-dropdown"
                :class="[isBottomDropdown ? 'top-3' : 'bottom-16']">
                <div class="max-h-64 overflow-y-auto hide-scroll">
                    <div v-for="(v) in monthList" :key="v.value"
                        class="py-2 px-4 border-b last:border-b-0 cursor-pointer hover:bg-gray-50 text-center"
                        @click="selectMonthItem(v)">
                        {{v.text}}
                    </div>
                </div>
            </div>
            <div v-show="showYearList && yearList.length > 0"
                ref="ddl-list-area"
                class="absolute left-0 w-full bg-white border rounded-md overflow-hidden z-index-dropdown"
                :class="[isBottomDropdown ? 'top-3' : 'bottom-16']">
                <div class="max-h-64 overflow-y-auto hide-scroll">
                    <div v-for="(v) in yearList" :key="v.value"
                        class="py-2 px-4 border-b last:border-b-0 cursor-pointer hover:bg-gray-50 text-center"
                        @click="selectYearItem(v)">
                        {{v.text}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { DropdownListValue } from "@/helper/FormHelper.js";
import Locale from "@/helper/locale/Locale.js";

export default {
    name: 'Inputselectdate',
    components:{

    },
    data: function() {
        return {
            monthList: [],
            yearList: [],
            test: null,
            showMonthList: false,
            showYearList: false,
            isBottomDropdown: true,
            selectYear: '',
            selectMonth: '',
            selectYearText: '',
            selectMonthText: ''
        };
    },
    created: function(){
        this.setMonthList();
        this.setYearList();
        this.innitCurrentDate();
    },
    methods: {
        innitCurrentDate: function(){
            let currentMonth = new Date().getUTCMonth() + 1;
            currentMonth = currentMonth.toString();
            let month = this.monthList.filter(data => data.value == currentMonth);
            this.selectYear = this.yearList.length ? this.yearList[0] : '';
            this.selectMonth = month.length ? month[0] : '';
            this.selectYearText = this.selectYear ? this.selectYear.text : '';
            this.selectMonthText = this.selectMonth ? this.selectMonth.text : '';
            if(this.selectMonth && this.selectYear){
                this.$emit('onChange', {month: this.selectMonth.value , year: this.selectYear.value});
            }
        },
        setMonthList: function() {
            let monthListItem = new DropdownListValue();

            let lbl = Locale.getLbl();
            let months = lbl.date.month_full;
            for (let i in months) {
                let index = parseInt(i, 10) + 1 + '';
                monthListItem.add(months[i], index);
            }
            this.monthList = monthListItem.getList();
        },
        setYearList: function() {
            let yearListItem = new DropdownListValue();

            let currentYear = parseInt(new Date().getFullYear(), 10);
            let yearText = currentYear;
            let localeCode = Locale.getLocaleCode();

            if (localeCode == 1054) {
                yearText = yearText + 543;
            }

            for (let i=0 ; i<100 ; i++) {
                yearListItem.add(yearText-i + '', currentYear-i + '');
            }
            this.yearList = yearListItem.getList();
        },
        selectYearItem: function(item){
            this.selectYear = item
            this.selectYearText = item.text
            this.showYearList = false;
            if(this.selectMonth && this.selectYear){
                this.$emit('onChange', {month: this.selectMonth.value , year: this.selectYear.value});
            }
        },
        selectMonthItem: function(item){
            this.selectMonth = item
            this.selectMonthText = item.text
            this.showMonthList = false;
            if(this.selectMonth && this.selectYear){
                this.$emit('onChange', {month: this.selectMonth.value , year: this.selectYear.value});
            }
        },
        showMonthDropdrow: function(){
            this.showMonthList = this.showMonthList ? false : true ;
            this.showYearList = false;
        },
        showYearDropdrow: function(){
            this.showYearList = this.showYearList ? false : true ;
            this.showMonthList = false;
        }
    },
};
</script>

<style lang="scss" scoped>

</style>
